<template>
    <div>
      <table class="table is-fullwidth" v-show="freight.length">
        <thead>
        <tr>
          <th><!-- left blank --></th>
          <th><!-- left blank --></th>
          <th>Documents</th>
          <th>Origin</th>
          <th>Destination</th>
          <th>Description</th>
          <th>Pallet Count</th>
        </tr>
        </thead>
        <tbody>
        <tr is="freight-table-row" v-for="(f, index) in freight" :key="index" v-model="freight[index]"
            @edit="editFreight(index)"
            @delete="removeFreight(index)"
            :origins="origins"
            :destinations="destinations"
        >
        </tr>
        </tbody>
      </table>

      <div class="card" v-show="showInputForm">
        <div class="card-content">
          <freight-from v-model="temp" />
        </div>
        <div class="card-footer">
          <div class="card-footer-item">
            <button type="button" :disabled="!canSave" class="button is-primary" @click="addFreight">Save line item</button>
            <div v-show="!canSave" class="is-size-7">
              Draft saving in progress, please wait
            </div>
          </div>
          <div class="card-footer-item">
            <button type="button" class="button" @click="toggleInputForm" :disabled="!this.freight.length">Cancel</button>
          </div>

        </div>
      </div>

      <button class="button is-success" v-show="!showInputForm" @click="toggleInputForm">
        <font-awesome-icon icon="plus" />
        Add another line item
      </button>

      <!--
      <div class="modal add-location-modal" :class="{ 'is-active': showAddModal }" v-show="showAddModal" >
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Add Freight</p>
          </header>

          <section class="modal-card-body">
            <freight-from v-model="temp" />

          </section>

          <footer class="modal-card-foot columns">
            <div class="column is-one-third">
              <button class="button " @click="toggleAddModal">Cancel</button>
            </div>
            <div class="column">
              <button class="button is-success" @click="addFreight">Add</button>
            </div>

          </footer>

        </div>

      </div>
      -->
    </div>
</template>

<script>
import { isEqual, uniqueId } from 'lodash-es'

import FreightFrom from '@/components/TransactionCreationWizard/FreightForm'
import FreightTableRow from '@/components/TransactionCreationWizard/FreightDescriber-row'
export default {
  name: 'FreightDescriber',

  props: {
    canSave: {
      // this props is sort of a hack. it is intended as a way to prevent the user from being able to trigger save-requests
      // requests at once when creating a new transaction
      type: Boolean,
      default: true
    },
    value: {
      type: Array
    },
    origins: {
      type: Array,
      required: true
    },
    destinations: {
      type: Array,
      required: true
    }
  },

  created() {
    this._copyPropToLocal()
  },

  data() {
    return {
      temp: {},
      showInputForm: true,
      freight: []
    }
  },

  components: {
    FreightFrom,
    FreightTableRow
  },

  methods: {
    toggleInputForm() {
      this.temp = {}
      this.showInputForm = !this.showInputForm
    },

    removeFreight(index) {
      const deleteCount = 1
      this.freight.splice(index, deleteCount)
    },

    editFreight(index) {
      // because everything is passed by reference in JS, we need to deep clone the object so that when its reset it
      // doesn't blow away the data we care about
      this.temp = JSON.parse(JSON.stringify(this.freight[index]))
      this.showInputForm = true
    },

    addFreight() {
      // because everything is passed by reference in JS, we need to deep clone the object so that when its reset it
      // doesn't blow away the data we care about
      const newFreight = JSON.parse(JSON.stringify(this.temp))
      newFreight.temporaryId = newFreight.temporaryId || uniqueId('freight')

      // if there is only one origin and one destination to choose from... pre-select them
      if (this.origins.length === 1) {
        newFreight.originKey = this.origins[0].companyJobPointKey
      }
      if (this.destinations.length === 1) {
        newFreight.destinationKey = this.destinations[0].companyJobPointKey
      }

      // check if the new freight is already in the list (aka: it was being edited) and update it rather than just adding a new entry
      const targetIndex = this.freight.findIndex((loc) => loc.temporaryId === newFreight.temporaryId)
      if (targetIndex !== -1) {
        this.freight.splice(targetIndex, 1, newFreight)
      } else {
        this.freight.push(newFreight)
      }

      this.toggleInputForm()
    },

    saveFreightHack() {
      // this is a hack to save the transaction every time a freight is added.
      // this is needed because we need a freightKey in order to upload documents to a freight...
      // ...and the only way to save freights is by saving the entire transaction
      this.$emit('save-hack')
    },

    notify() {
      let newFreightAdded = false
      if (this.freight.length > this.value.length) {
        newFreightAdded = true
      }

      if (!isEqual(this.freight, this.value)) {
        // return a copy of freights, otherwise the parent and this component will share the sme values
        this.$emit('input', [...this.freight])
      }

      if (newFreightAdded) {
        this.saveFreightHack()
      }
    },

    _copyPropToLocal() {
      this.freight = this.value.map((freight) => {
        return {
          ...freight,
          // set the key returned from the server as the uniqueId, otherwise generate our own
          temporaryId: freight.companyJobFreightKey || uniqueId('freight')
        }
      })
    }
  },

  watch: {
    freight: {
      deep: true,
      handler() {
        this.notify()
        if (this.freight.length) {
          this.showInputForm = false
        } else {
          this.showInputForm = true
        }
      }
    },
    value() {
      if (!isEqual(this.freight, this.value)) {
        this._copyPropToLocal()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-footer-item {
  flex-direction: column;
}

.add-location-modal {
  .modal-card {
    height: 90vh;
  }

  .modal-card-foot .column .button {
    width: 100%;
  }
}
</style>
